const getBaseUrl = () => {
    const currentDomain = window.location.hostname;
    if(currentDomain === 'localhost'){
        return 'http://localhost:5001'; 
    }else{
        return `https://${currentDomain}/security`;
    }
};

const baseURL = getBaseUrl();

export default baseURL;
